import {
  SoftwarePackage,
  SoftwarePackageType,
  SoftwarePublisher
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

import { SelectSoftwarePackageVersionFilterValues } from "./SelectSoftwarePackageVersionFilter";

export const filterAndSortSoftwarePackages = (
  softwarePackagesData: SelectSoftwarePackageSummaryDto[],
  filter: SelectSoftwarePackageVersionFilterValues
): SelectSoftwarePackageSummaryDto[] => {
  return softwarePackagesData
    .filter(
      d =>
        filter.name === "" ||
        d.displayName.toLowerCase().indexOf(filter.name.toLowerCase()) >= 0
    )
    .sort(
      (
        a: SelectSoftwarePackageSummaryDto,
        b: SelectSoftwarePackageSummaryDto
      ) => {
        return a.displayName < b.displayName ? 1 : -1;
      }
    );
};

// Get view of software packages and their publishers
export function getSoftwarePackageSummary(
  softwarePackages: SoftwarePackage[],
  softwarePublishers: SoftwarePublisher[]
): SelectSoftwarePackageSummaryDto[] {
  const packages = softwarePackages.map(softwarePackage => {
    const publisher = softwarePublishers.find(
      x => x.id === softwarePackage.softwarePublisherId
    );

    return {
      softwarePackageId: softwarePackage.id,
      code: softwarePackage.code,
      displayName: softwarePackage.displayName,
      description: softwarePackage.description,
      softwarePackageType: softwarePackage.softwarePackageType,
      softwarePublisher: publisher?.code
    } as SelectSoftwarePackageSummaryDto;
  });

  return packages;
}

export interface SelectSoftwarePackagesFormValues {
  packages: SelectSoftwarePackageFormValues[];
}

export interface SelectSoftwarePackageFormValues {
  softwarePackageId: string;
  code: string;
  displayName: string;
  description?: string;
  softwarePackageType: SoftwarePackageType;
  softwarePublisher: string;
  softwarePackageVersionId?: string;
}

// Don't permit the user to add these software package types
export const dependentSoftwarePackageTypes = [
  SoftwarePackageType.Bundle,
  SoftwarePackageType.Dependency
];

// Exclude the maintenance software package codes as they are set as default versions, but not the action man
export const excludedMaintenanceSoftwarePackageCodes = [
  "ActionRunner",
  "Maintenance"
];

export interface SelectSoftwarePackageSummaryDto {
  softwarePackageId: string;
  code: string;
  displayName: string;
  description?: string;
  softwarePackageType: SoftwarePackageType;
  softwarePublisher: string;
}
